$(function(){
    $('.js-job-header').on('click', function (e) {
        e.preventDefault();
        var $parent = $(e.target).parents('.job');
        if ($parent.hasClass('job--active')) {
            $parent.removeClass('job--active');
        } else {
            $parent.addClass('job--active');
        }
    });
});